export default __webpack_public_path__ + "static/media/badges.84095c7b.svg";